import { ColumnProps } from "antd/lib/table";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import OrderContext from "../../../context/order/context";
import { ISort, IStaticFilter } from "../../../models/base/base-query";
import { IOrderShort } from "../../../models/order/response";
import { tableOnChange } from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";
import Tag from "../../general/antd/tag";
import {
  getOrderStatus,
  getOrderStatusColor,
  getDeliveryModeName,
  getDeliveryModeColor,
} from "../../../models/order/enum";
import moment from "moment";
import styles from './styles.module.scss'
import TripBadge from "../trip-badge";
import Space from "../../general/antd/space";
import DeliveryModeEditButton from "../delivery-mode-edit-button";
import { ImCross } from "react-icons/im";
import { isLocationChanged } from "../../../utils/helpers/order.helpers";
interface IProps {}

const OrderShortTable: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { listShort, actions, loading, query } = useContext(OrderContext);

  const columns: ColumnProps<IOrderShort>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      sorter: {
        multiple: 1,
      },
      width: 100,
      align: "center",
    },
    {
      title: t("number_id"),
      dataIndex: "number",
      key: "number",
      sorter: {
        multiple: 1,
      },
      width: 100,
      align: "center",
    },
    {
      title: t("delivery_store"),
      dataIndex: "deliveryStore",
      key: "deliveryStore",
      align: "center",
      width: 200,
      render: (_, record) => {
        return <Tag title={record?.deliveryStore?.name ?? "-"}/>;
      },
    },
    {
      title: t("trip_info"),
      dataIndex: "tripId",
      key: "tripId",
      align: "center",
      width: 150,
      render: (_, record) => {
        return (
          <TripBadge
            tripId={record?.tripId}
            tripNumber={record?.tripNumber}
            tripStatus={record?.tripStatus}
          />
        );
      },
    },
    {
      title: t("delivery_mode"),
      dataIndex: "deliveryMode",
      key: "deliveryMode",
      align: "center",
      width: 200,
      render: (_, record) => {
        return (
          <Space size="small" align="center">
            <Tag
              title={t(getDeliveryModeName(record?.deliveryMode))}
              color={getDeliveryModeColor(record?.deliveryMode)}
            />
            <DeliveryModeEditButton
              order={record}
              onSuccess={() => actions.getDataShort()}
              size="small"
            />
          </Space>
        );
      },
    },
    {
      title: t("store"),
      dataIndex: "store",
      align: "center",
      key: "store",
      width: 200,
      render: (_, record) => {
        return <Tag title={record?.store?.name ?? "-"} />;
      },
    },
    {
      title: t("location_changed"),
      dataIndex: "locationChanged",
      align: "center",
      key: "locationChanged",
      width: 200,
      render: (_, record) => {
        if (!isLocationChanged(record?.locationChanged)) {
          return <ImCross color="red" />;
        }
        return (
          <div style={{ fontSize: "12px", textAlign: "start" }}>
            <div><strong>{t("browsing_store")}:</strong> {record?.browsingStore?.name ?? "-"}</div>
            <div><strong>{t("browsing_total_price")}:</strong> {record?.browsingTotalPrice?.toLocaleString() ?? 0}</div>
            <div><strong>{t("delivery_total_price")}:</strong> {record?.deliveryTotalPrice?.toLocaleString() ?? 0}</div>
            <div>
              <strong>{t("price_difference")}:</strong>{" "}
              <span style={{ color: (record?.priceDifference ?? 0) > 0 ? "red" : "green", fontWeight: 600 }}>
                {(record?.priceDifference ?? 0) > 0 ? "+" : ""}{record?.priceDifference?.toLocaleString() ?? 0}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: t("current_order_status"),
      dataIndex: "status",
      align: "center",
      key: "status",
      width: 250,
      render: (_, record) => {
        return (
          <Tag
            title={getOrderStatus(record?.status)}
            color={getOrderStatusColor(record?.status)}
          />
        );
      },
    },
    {
      title: t("created_at"),
      dataIndex: "createdAt",
      align: "center",
      key: "createdAt",
      minWidth: 100,
      render: (_, record) => {
        return moment(record?.createdAt).format("YYYY-MM-DD");
      },
    },
    
  ];

  let tableFiltersProps = {};
  const [sorts, setSorts] = useState<ISort[]>([]);
  const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

  useEffect(() => {
    sorts.length > 0 &&
      actions.setQuery({
        ...query,
        orders: sorts,
      });
  }, [sorts]);

  return (
    <>
      <Table<any>
        rowKey="id"
        showPagination={true}
        columns={columns}
        className={styles.table}
        dataSource={listShort?.data ?? []}
        loading={loading.includes("list") || listShort == undefined}
        size="small"
        total={listShort?.total}
        pageSize={query.perPage}
        page={query.page}
        onPaginationChange={(page, pageSize) => {
          actions.setQuery({
            ...query,
            page,
            perPage: pageSize,
          });
        }}
       
        onChange={(_, tableFilters, tabelSorters) => {
          tableOnChange(
            tableFilters,
            tabelSorters,
            tableFiltersProps,
            setSorts,
            setStaticFilters
          );
        }}
      />
    </>
  );
};

export default OrderShortTable;
